import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name:'BarChart',
  extends: Bar,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    ////console.log(this.options);

    this.renderChart(this.chartData, this.options)
  }
}